import Vue from 'vue';
import Vuex from 'vuex';
import {
  GlobalApi,
  WeightApi
} from '@/api'
import Util from '@/common/js/util'

Vue.use(Vuex);

const state = {
  Archives: '',
  // UserInfo: {},
  // HistoryState: {},
  // EnableTaokoulingMask: true,
  // AuthConfig: new Map()
}

// getters
const getters = {
  // UserInfo: state => state.UserInfo,
  // HistoryState: state => state.HistoryState,
  // EnableTaokoulingMask: state => state.EnableTaokoulingMask,
  // AuthConfig: state => state.AuthConfig
}

const actions = {
  // setUserInfo ({ commit, state }, data){
  //   commit('setUserInfo', { data })
  // },
  // setHistoryState ({ commit, state }, data) {
  //   commit('setHistoryState', { data })
  // },
  // setEnableTaokoulingMask ({ commit, state }, data) {
  //   commit('setEnableTaokoulingMask', { data })
  // },
  // 获取用户信息
  // getUserInfo ({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     if (state.UserInfo && Object.keys(state.UserInfo).length > 0) {
  //       return resolve()
  //     }
  //     WeightApi.getUserInfo().then(data => {
  //       if (data.Status === 200) {
  //         commit('setUserInfo', { data: { ...data.Result, Auth: Util.getSearchJson().auth }})
  //         resolve()
  //       } else {
  //         reject(new Error(data.Result.ErrorMsg))
  //       }
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  // // 获取授权域名等配置
  // getAuthConfig ({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     if (state.AuthConfig && state.AuthConfig.size > 0) {
  //       return resolve()
  //     }
  //     GlobalApi.getDicInfoByKey({ key: 'AuthConfig' }).then(data => {
  //       if (data.Status === 200) {
  //         commit('setAuthConfig', new Map((data.Result || []).map(item => [item.key, item.value])))
  //         resolve()
  //       } else {
  //         reject(new Error(data.Result.ErrorMsg))
  //       }
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // }
}

const mutations = {
  // setUserInfo (state, { data }) {
  //   state.UserInfo = { ...data, ...(process.env.ENV_CONFIG === 'dev' ? { ComplaintJumpUrl: '' } : {}) }
  // },
  // setHistoryState (state, { data }) {
  //   state.HistoryState = data
  // },
  // setEnableTaokoulingMask (state, { data }) {
  //   state.EnableTaokoulingMask = data
  // },
  // setAuthConfig (state, data) {
  //   state.AuthConfig = data
  // }

  editStateFn(state, {
    field,
    val
  }) {
    state[field] = val;
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {}
})



// WEBPACK FOOTER //
// ./src/vuex/index.js